<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div id="caseHeader" class="page-name color-71aa3f">
                        Create Case
                    </div>
                    <button type="submit" class="btn general-button btn-primary" v-on:click.prevent="backShowCase">
                        Back
                    </button>
                </div>
                <div v-if="isDataEditable == true">
                    <div class="admin-page-content">
                        <form id="caseform">
                            <div class="forms-container">
                                <div class="row no-margin">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                        <div class="alert alert-success" id="alertSuccess">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <span>Case Added Successfully</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                        <div class="alert alert-danger" id="alertError">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <span id="errorMsg" class="error"></span>
                                        </div>
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Customer</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <v-select v-model="customer_id" v-on:change="customerChangedValue" name="customer_id" label="text" :filterable="false" :options="customerArr" @search="onSearchCustomer" v-on:click="getAccountId(customer_id.value)" v-validate="'required'"
                                                      placeholder="Select Related Account">
                                                <template slot="no-options">
                                                    Search Related Accounts...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="requiredstar">*</div>
                                            <span v-show="errors.has('customer_id')" class="help is-danger"><font color="red">Related Account is Required</font></span>
                                        </div>    
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Contact</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <v-select v-model="contact_id" 
                                                      :searchable="false" 
                                                      @change="contactChangedValue" 
                                                      name="contact_id" 
                                                      label="text" 
                                                      :filterable="false" 
                                                      :options="contactArr" 
                                                      @search="onSearchContact" 
                                                      v-validate="'required'"
                                                      placeholder="Select Related Contact">
                                                <template slot="no-options">
                                                    Search Related Contacts...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="requiredstar">*</div>
                                            <span v-show="errors.has('contact_id')" class="help is-danger"><font color="red">Releted Contact is Required</font></span>
                                        </div>    
                                    </div>
                                    <!-- TODO: verify below -->
                                    <!-- <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Collector</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <span class="form-control">{{user_id.text}}</span> -->
                                            <!--<v-select 
                                                    v-model="user_id" 
                                                    @change="userChangedValue" 
                                                    name="user_id" 
                                                    label="text" 
                                                    :filterable="false" 
                                                    :options="usersArr" 
                                                    @search="onSearch"
                                                    v-validate="'required'"
                                                    placeholder="Select Collector">
                                                    <template slot="no-options">
                                                        Search Collectors...
                                                    </template>
                                                    <template slot="option" slot-scope="option">
                                                        <div class="d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                        <div class="selected d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                </v-select>
                                                <span v-show="errors.has('user_id')" class="help is-danger" v-if="errors.has('user_id')"><font color="red">Collector is Required</font></span>-->
                                        <!-- </div>    
                                    </div> -->
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Assigned Internal User</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <v-select v-model="assigned_to_id" @change="assignedUserChangedValue" name="assigned_to_id" label="text" :filterable="false" :options="assignedUsersArr" @search="onSearchAssignedUser" v-validate="'required'"
                                                      placeholder="Select Assigned Internal User">
                                                <template slot="no-options">
                                                    Search Assigned Internal Users...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="requiredstar">*</div>
                                            <span v-show="errors.has('assigned_to_id')" class="help is-danger"><font color="red">Assigned Internal User is Required</font></span>
                                        </div>    
                                    </div>
                                    <div class="col-12 forms-block">
                                        <div class="col-1point5 paddingleft0">
                                            <div class="form-label"><strong>Subject</strong></div>
                                        </div>
                                        <div class="col-10point5 paddingleft0">
                                            <input name="subject" id="subject"
                                                   class="form-control no-resize" v-model="subject"
                                                   placeholder="Enter Subject"
                                                   v-validate="'required'">
                                            <!--v-validate="'required|max:190'">-->
                                            <div class="requiredstar">*</div>
                                            <span v-if="errors.has('subject')" v-show="subject == ''" class="help is-danger"><font color="red">Subject is required</font></span>
                                            <!--<span v-if="errors.firstByRule('subject','max')" v-show="subject != ''" class="help is-danger"><font color="red">Subject maximum length must be 190 characters</font></span>-->
                                        </div>    
                                    </div>
                                    <div class="col-12 forms-block">
                                        <div class="col-1point5 paddingleft0">
                                            <div class="form-label"><strong>Description</strong></div>
                                        </div>
                                        <div class="col-10point5 paddingleft0">
                                            <textarea name="description" id="description" rows="10"
                                                      class="form-control no-resize" v-model="description"
                                                      placeholder="Enter Description"></textarea>
                                        </div>    
                                    </div>
                                    <div class="col-12 forms-block">
                                        <div class="col-1point5 paddingleft0">
                                            <div class="form-label"><strong>Resolution</strong></div>
                                        </div>
                                        <div class="col-10point5 paddingleft0">
                                            <textarea name="resolution" id="resolution" rows="10"
                                                      class="form-control no-resize" v-model="resolution" v-validate="'required'"
                                                      placeholder="Enter Resolution"></textarea>
                                            <div class="requiredstar">*</div>
                                            <span v-show="errors.has('resolution')" class="help is-danger"><font color="red">Resolution is Required</font></span>
                                        </div>    
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Priority</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <v-select
                                                name="priority"
                                                v-model="priority"
                                                id="priority" label="text"
                                                :options="priorityArr"
                                                :required="true"
                                                v-validate="'required'"></v-select>
                                            <div class="requiredstar">*</div>
                                            <span v-show="errors.has('priority')" class="help is-danger"><font color="red">Priority is Required</font></span>
                                        </div>    
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Dispute Type</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <v-select
                                                name="dispute_type"
                                                v-model="dispute_type"
                                                id="dispute_type" label="text"
                                                :options="DisputeArr"
                                                :required="true"
                                                v-validate="'required'"
                                                ></v-select>
                                            <div class="requiredstar">*</div>
                                            <span v-show="errors.has('dispute_type')" class="help is-danger"><font color="red">Dispute Type is Required</font></span>
                                        </div>    
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Status</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <v-select
                                                name="status"
                                                v-model="status"
                                                id="status" label="text"
                                                :options="statusArr"
                                                :required="true"
                                                v-validate="'required'"></v-select>
                                            <div class="requiredstar">*</div>
                                            <span v-show="errors.has('status')" class="help is-danger"><font color="red">Status is Required</font></span>
                                        </div>    
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Source</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <v-select
                                                name="source"
                                                v-model="source"
                                                id="source" label="text"
                                                :options="sourceArr"
                                                :required="true"
                                                v-validate="'required'"></v-select>
                                            <div class="requiredstar">*</div>
                                            <span v-show="errors.has('source')" class="help is-danger"><font color="red">Source is Required</font></span>
                                        </div>    
                                    </div>
                                    <div class="col-12 forms-block">
                                        <div class="col-12 paddingleft0">
                                            <div class="form-label"><strong>Created By</strong> : {{ firstName }} {{ lastName }}</div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="col-12 paddingleft0">
                                            <input id="addCaseBtn" type="submit" value="Save" class="btn general-button btn-primary" v-on:click.prevent="addCase()">
                                            <!-- <button id="addCaseBtn" type="submit" class="btn general-button btn-primary" v-on:click.prevent="addCase">{{btn}}</button> -->
                                            <input id="addAndContinueCaseBtn" type="submit" value="Save and Continue" class="btn general-button btn-primary" v-on:click.prevent="addCase(flag='Save and Continue')">
                                            <input id="CancelCase" type="submit" value="Cancel" class="btn general-button btn-primary" v-on:click.prevent="backShowCase">
                                        </div>
                                    </div>
                                </div>    
                            </div>    
                        </form>    
                    </div>
                </div>
                <div v-if="isDataEditable == false" >
                    <div class="admin-page-content">
                        <div class="col-md-12 error-detail-main forms-container">
                            <div class="error-template">
                                <h1>Oops!</h1>
                                <!--<h2>403</h2>-->
                                <div class="error-details">Sorry You can't Edit This Record...</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>

</template>
<script>
    import Vue from "vue";
    import VeeValidate from "vee-validate";
    Vue.use(VeeValidate);
    import EventBus from "../event-bus";
    import SessioMixin from '../../mixins/sessionmixin';
    import FrontFooter from '@/components/partials/FrontFooter';
    var contex;
    export default {
        name: "CaseCreate",
        mixins: [SessioMixin],
        components: {
            'app-footer': FrontFooter,
        },
        data() {
            return {
                cantAccessPage: true,
                isShowLoggedinfields: true,
                firstName: "",
                lastName: "",
                userName: "",
                customerId: 0,
                isLoggedIn: false,
                description: "",
                resolution: "",
                subject: "",
                // btn:"Save",
                status: {value: "open", text: "Open"},
                source: {value: "other", text: "Other"},
                priority: {value: "normal", text: "Normal"},
                dispute_type: {value: "pricing", text: "Pricing"},
                user_id: "",
                usersArr: [],
                customer_id: "",
                customerArr: [],
                options: "",
                assigned_to_id: "",
                assignedUsersArr: [],
                contact_id: "",
                contactArr: [],
                sourceArr: [
                    {value: "email", text: "Email"},
                    {value: "other", text: "Other"},
                    {value: "phone", text: "Phone"},
                    {value: "web", text: "Web"}
                ],
                statusArr: [
                    {value: "open", text: "Open"},
                    {value: "in_progress", text: "In Progress"},
                    {value: "resolved", text: "Resolved"},
                    {value: "closed", text: "Closed"}
                ],
                priorityArr: [
                    {value: "low", text: "Low"},
                    {value: "normal", text: "Normal"},
                    {value: "high", text: "High"}
                ],
                DisputeArr: [
                    {value: "pricing", text: "Pricing"},
                    {value: "cc_chargeback", text: "CC Chargeback"},
                    {value: "check_bank_deposit", text: "Check: Bank Deposit"},
                    {value: "check_guaranteed", text: "Check: Guaranteed"},
                    {value: "sales_tax", text: "Sales Tax"}
                ],
                customer_contact_id: {value: ""},
                isDataEditable: true,
                loginID: ""
            };
        },
        watch: {
            customer_id: function (customer_id) {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/get/contact_details",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        customer_id: customer_id.value
                    },
                    dataType: "json",
                    success: function (data) {
                        if (customer_id.value) {
                            self.contact_id = {value: data.content[0].value, text: data.content[0].text};
                            self.contactArr = data.content;
                        }
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            if (jqXHR.status == 401) {
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },
            // contact_id: function (contact_id) {
            //     var self = this;
            //     var path = window.location.pathname;
            //     var segments = path.split("/");
            //     if (segments[2] != 'update') {
            //         if (typeof (contact_id) == "undefined" || contact_id == null) {
            //             self.user_id = {value: '', text: ''};
            //         } else {
            //             if (contact_id == '') {
            //                 self.user_id = {value: '', text: ''};
            //             } else {
            //                 $.ajax({
            //                     url: process.env.ROOT_API + "/get/contact/user",
            //                     type: "GET",
            //                     headers: {
            //                         Accept: "application/json",
            //                         "Access-Control-Allow-Origin": "*",
            //                         Authorization: "Bearer " + localStorage.getItem("api_token"),
            //                         "Access-Control-Allow-Headers":
            //                                 "Origin, Content-Type, Authorization,X-Requested-With",
            //                         "Cache-Control": "no-cache"
            //                     },
            //                     data: {
            //                         contact_id: contact_id.value
            //                     },
            //                     dataType: "json",
            //                     success: function (data) {
            //                         if (contact_id.value) {
            //                             self.assigned_to_id = self.user_id = {value: data[0].value, text: data[0].text};
            //                             self.assignedUsersArr = self.usersArr = data;
            //                         }
            //                     },
            //                     error: function (jqXHR, exception) {
            //                         if (jqXHR.status == 0) {
            //                             self.error = "Remote server can not be reachable";
            //                         } else {
            //                             if (jqXHR.status == 401) {
            //                                 localStorage.removeItem("user_obj");
            //                                 localStorage.removeItem("api_token");
            //                                 self.$router.push("/login");
            //                             }
            //                             self.error = jqXHR.responseJSON.message;
            //                         }
            //                     }
            //                 });
            //             }
            //         }

            //     }
            // }
        },
        beforeMount: function () {
            var app = this;
            contex = this;
            var check = window.localStorage.getItem("api_token");

            if (check != null) {
                this.isLoggedIn = true;
                app.getPermissions();
            }
        },
        mounted: function () {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            $(".removeActive").removeClass("active");
            if (segments[2] == 'update') {
                if (segments[4] != 0) {
                    $("#menucustomers").addClass("active");
                } else {
                    $("#menucases").addClass("active");
                }
            } else {
                if (segments[3] != 0) {
                    $("#menucustomers").addClass("active");
                } else {
                    $("#menucases").addClass("active");
                }
            }
            if (localStorage.getItem("menu_small") == "1") {
                self.menuSmall();
            } else {
                self.menuBig();
            }
            if (segments[2] == 'update') {
                if (segments[3]) {
                    self.showLoader();
                    //console.log(segments[3]);
                    self.loadCase();
                    // $("#addAndContinueCaseBtn").prop('disabled',true);
                    $("#addAndContinueCaseBtn").hide();
                    $("#addCaseBtn").val("Update");
                    $("#caseHeader").text("Edit Case");
                }
            } else {
                if (segments[3] != 0) {
                    self.customerId = segments[3];
                    self.loadCustomeradd();
                }
            }
            //console.log(segments[3]);
            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginID = userJson.id;
                EventBus.$emit(
                        "logged-in",
                        false,
                        userJson["first_name"],
                        userJson["last_name"],
                        userJson["email"]
                        );
            }
        },
        methods: {
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_add_new_case') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            backShowCase() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                if (segments[2] == 'update') {
                    if (segments[4] != 0) {
                        self.$router.push("/customer/view/" + segments[4]);
                    } else {
                        self.$router.push("/case/list");
                    }
                } else {
                    if (segments[3] != 0) {
                        self.$router.push("/customer/view/" + segments[3]);
                    } else {
                        self.$router.push("/case/list");
                    }
                }
            },
            contactChangedValue: function (value) {
                //console.log("", value);
            },

            userChangedValue: function (value) {
                //console.log("", value);
            },
            assignedUserChangedValue: function (value) {
                //console.log("", value);
            },
            customerChangedValue: function (value) {
                //console.log("", value);

                //console.log(self.customer_id.value);
            },
            onSearch(search, loading) {
                if (search.length > 2) {
                    loading(true);
                    this.loadUser(loading, search, this);
                }
            },
            onSearchAssignedUser(search, loading) {
                if (search.length > 2) {
                    loading(true);
                    this.loadAssignedUser(loading, search, this);
                }
            },
            onSearchCustomer(search, loading) {
                if (search.length > 2) {
                    loading(true);
                    this.loadCustomer(loading, search, this);
                }
            },
            onSearchContact(search, loading) {
                /*if (search.length > 2) {
                 loading(true);
                 this.loadContact(loading, search, this);
                 }*/
            },
            onSubmit(flag) {
                this.$validator.validateAll();

                if (!this.errors.any()) {
                    this.addCase(flag);
                }
            },
            loadCustomeradd() {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/get/customers",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        default: self.customerId
                    },
                    dataType: "json",
                    success: function (data) {
                        self.customer_id = {value: data[0].value, text: data[0].text};
                        self.customerArr = data;
                        // console.log(self.customerArr.data());
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            loadCustomer(loading, search, vm) {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/get/customers",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search
                    },
                    dataType: "json",
                    success: function (data) {
                        loading(false);

                        self.customerArr = data;
                        //console.log(self.customerArr);
                        for (var i = 0; i < self.customerArr.length; i++) {
                            var id = self.customerArr[i]["value"];
                            //console.log(id);
                        }

                        // console.log(self.customerArr.data());
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            loadContact(loading, search, vm) {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/get/contacts",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search
                    },
                    dataType: "json",
                    success: function (data) {
                        loading(false);

                        self.contactArr = data;

                        // console.log(self.customerArr.data());
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            loadUser(loading, search, vm) {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/get/users",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search,
                        type: 'collector',
                    },
                    dataType: "json",
                    success: function (data) {
                        loading(false);

                        self.usersArr = data;

                        //console.log(self.usersArr);
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            loadAssignedUser(loading, search, vm) {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/get/users",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search,
                        /*type: 'collector',*/
                    },
                    dataType: "json",
                    success: function (data) {
                        loading(false);

                        self.assignedUsersArr = data;

                        //console.log(self.assignedUsersArr);
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            addCase(flag) {
                this.$validator.validate().then(result => {
                    if (result) {
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        var self = this;
                        //console.log(segments[3]);
                        if (segments[2] == 'update') {
                            if (segments[3]) {
                                //console.log(segments[3]);
                                $("#addCaseBtn").val("Updating ...");
                                $("#addCaseBtn").prop("disabled", true);
                                // $("#addAndContinueCaseBtn").prop('disabled',true);
                                $("#CancelCase").prop("disabled", true);
                                // this.$validator.validateAll();
                                // this.$validator.errors.clear();
                            } else {
                                if (flag == "Save and Continue") {
                                    $("#addAndContinueCaseBtn").val("Saving ...");
                                    $("#addAndContinueCaseBtn").prop("disabled", true);
                                    $("#addCaseBtn").prop("disabled", true);
                                    $("#CancelCase").prop("disabled", true);
                                } else {
                                    $("#addCaseBtn").val("Saving ...");
                                    $("#addCaseBtn").prop("disabled", true);
                                    $("#addAndContinueCaseBtn").prop("disabled", true);
                                    $("#CancelCase").prop("disabled", true);
                                }
                            }
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueCaseBtn").val("Saving ...");
                                $("#addAndContinueCaseBtn").prop("disabled", true);
                                $("#addCaseBtn").prop("disabled", true);
                                $("#CancelCase").prop("disabled", true);
                            } else {
                                $("#addCaseBtn").val("Saving ...");
                                $("#addCaseBtn").prop("disabled", true);
                                $("#addAndContinueCaseBtn").prop("disabled", true);
                                $("#CancelCase").prop("disabled", true);
                            }
                        }
                        var fields = $("#caseform").serializeArray();
                        fields.push({name: "source", value: self.source.value});
                        fields.push({name: "status", value: self.status.value});
                        fields.push({name: "priority", value: self.priority.value});
                        fields.push({name: "dispute_type", value: self.dispute_type.value});
                        fields.push({name: "contact_id", value: self.contact_id.value});
                        fields.push({name: "customer_id", value: self.customer_id.value});
                        fields.push({name: "user_id", value: self.user_id.value});
                        fields.push({
                            name: "assigned_to_id",
                            value: self.assigned_to_id.value
                        });

                        if (segments[2] == 'update') {
                            if (segments[3]) {
                                fields.push({name: "id", value: segments[3]});
                                fields.push({name: "source", value: self.source.value});
                                fields.push({name: "status", value: self.status.value});
                                fields.push({name: "priority", value: self.priority.value});
                                fields.push({
                                    name: "dispute_type",
                                    value: self.dispute_type.value
                                });
                            } else {
                                fields.push({name: "id", value: 0});
                            }
                        } else {
                            fields.push({name: "id", value: 0});
                        }
                        self.showLoader();
                        $.ajax({
                            url: process.env.ROOT_API + "/case/create",
                            type: "POST",
                            data: fields,
                            headers: {
                                Accept: "application/json",
                                "Access-Control-Allow-Origin": "*",
                                Authorization: "Bearer " + localStorage.getItem("api_token"),
                                "Access-Control-Allow-Headers":
                                        "Origin, Content-Type, Authorization,X-Requested-With",
                                "Cache-Control": "no-cache"
                            },
                            dataType: "json",
                            success: function (data) {
                                self.hideLoader();
                                if (segments[2] == 'update') {
                                    if (segments[3]) {
                                        //console.log(segments[3]);
                                        $("#addCaseBtn").val("Update");
                                        $("#addCaseBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelCase").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueCaseBtn").val("Save and Continue");
                                            $("#addAndContinueCaseBtn").prop("disabled", false);
                                            $("#addCaseBtn").prop("disabled", false);
                                            $("#CancelCase").prop("disabled", false);
                                        } else {
                                            $("#addCaseBtn").val("Save");
                                            $("#addCaseBtn").prop("disabled", false);
                                            $("#addAndContinueCaseBtn").prop("disabled", false);
                                            $("#CancelCase").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueCaseBtn").val("Save and Continue");
                                        $("#addAndContinueCaseBtn").prop("disabled", false);
                                        $("#addCaseBtn").prop("disabled", false);
                                        $("#CancelCase").prop("disabled", false);
                                    } else {
                                        $("#addCaseBtn").val("Save");
                                        $("#addCaseBtn").prop("disabled", false);
                                        $("#addAndContinueCaseBtn").prop("disabled", false);
                                        $("#CancelCase").prop("disabled", false);
                                    }
                                }

                                if (data.status == "success") {
                                    if (flag == "Save and Continue") {
                                        $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").parent().removeClass("hide");
                                        $(".alert-success").parent().addClass("show");
                                        self.description = '';
                                        self.resolution = '';
                                        self.subject = '';
                                        self.status = {value: 'open', text: "Open"};
                                        self.source = {value: 'other', text: "Other"};
                                        self.priority = {value: 'normal', text: "Normal"};
                                        self.dispute_type = {value: 'pricing', text: "Pricing"};
                                        self.user_id = '';
                                        self.customer_id = '';
                                        self.assigned_to_id = '';
                                        self.contact_id = '';
                                        self.usersArr = [];
                                        self.customerArr = [];
                                        self.assignedUsersArr = [];
                                        if (segments[3] != 0) {
                                            self.customerId = segments[3];
                                            self.loadCustomeradd();
                                        }
                                        setTimeout(function () {
                                            $(".alert-success").parent().removeClass("show");
                                            $(".alert-success").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        self.backShowCase();
                                    }
                                } else {
                                    if (data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < data.content.length; i++) {
                                            err += data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    }
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.hideLoader();
                                if (segments[2] == 'update') {
                                    if (segments[3]) {
                                        $("#addCaseBtn").val("Update");
                                        $("#addCaseBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelCase").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueCaseBtn").prop("disabled", false);
                                            $("#addAndContinueCaseBtn").val("Save and Continue");
                                            $("#addCaseBtn").prop("disabled", false);
                                            $("#CancelCase").prop("disabled", false);
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");
                                            self.description = '';
                                            self.resolution = '';
                                            self.subject = '';
                                            self.status = {value: 'open', text: "Open"};
                                            self.source = {value: 'other', text: "Other"};
                                            self.priority = {value: 'normal', text: "Normal"};
                                            self.dispute_type = {value: 'pricing', text: "Pricing"};
                                            self.user_id = '';
                                            self.customer_id = '';
                                            self.assigned_to_id = '';
                                            self.contact_id = '';
                                            self.usersArr = [];
                                            self.customerArr = [];
                                            self.assignedUsersArr = [];
                                            $("#due_date").val("");
                                            if (segments[3] != 0) {
                                                self.customerId = segments[3];
                                                self.loadCustomeradd();
                                            }
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addCaseBtn").val("Save");
                                            $("#addCaseBtn").prop("disabled", false);
                                            $("#addAndContinueCaseBtn").prop("disabled", true);
                                            $("#CancelCase").prop("disabled", false);
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueCaseBtn").prop("disabled", false);
                                        $("#addAndContinueCaseBtn").val("Save and Continue");
                                        $("#addCaseBtn").prop("disabled", false);
                                        $("#CancelCase").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        self.description = '';
                                        self.resolution = '';
                                        self.subject = '';
                                        self.status = {value: 'open', text: "Open"};
                                        self.source = {value: 'other', text: "Other"};
                                        self.priority = {value: 'normal', text: "Normal"};
                                        self.dispute_type = {value: 'pricing', text: "Pricing"};
                                        self.user_id = '';
                                        self.customer_id = '';
                                        self.assigned_to_id = '';
                                        self.contact_id = '';
                                        self.usersArr = [];
                                        self.customerArr = [];
                                        self.assignedUsersArr = [];
                                        $("#due_date").val("");
                                        if (segments[3] != 0) {
                                            self.customerId = segments[3];
                                            self.loadCustomeradd();
                                        }
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addCaseBtn").val("Save");
                                        $("#addCaseBtn").prop("disabled", false);
                                        $("#addAndContinueCaseBtn").prop("disabled", true);
                                        $("#CancelCase").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    }
                                }

                                if (jqXHR.status == 0) {
                                    self.errorMsg = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (jqXHR.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/login");
                                    }
                                    $("#errorMsg").html(jqXHR.responseJSON.message);
                                    $(".alert-danger").parent().removeClass("hide");
                                    $(".alert-danger").parent().addClass("show");
                                    setTimeout(function () {
                                        $(".alert-danger").parent().removeClass("show");
                                        $(".alert-danger").parent().addClass("hide");
                                    }, 5000);
                                }
                            }
                        });
                    }
                });
            },
            loadCase() {
                var path = window.location.pathname;
                var segments = path.split("/");
                //console.log(segments[3]);
                var self = this;
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/case/" + segments[3],
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    // dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        if (data[0].created_by == self.loginID) {
                            //console.log(data);
                            self.description = data[0].description;
                            self.resolution = data[0].resolution;
                            self.subject = data[0].subject;
                            self.source = {
                                value: data[0].source,
                                text: self.formatString(data[0].source)
                            };
                            self.status = {
                                value: data[0].status,
                                text: self.formatString(data[0].status)
                            };
                            self.priority = {
                                value: data[0].priority,
                                text: self.formatString(data[0].priority)
                            };
                            self.dispute_type = {
                                value: data[0].dispute_type,
                                text: self.formatString(data[0].dispute_type)
                            };
                            self.user_id = {
                                value: data[0].user_id,
                                text:
                                        data[0].user_first_name +
                                        " " +
                                        data[0].user_last_name /*+
                                         " - " +
                                         data[0].user_email*/
                            };
                            self.assigned_to_id = {
                                value: data[0].assigned_to_id,
                                text:
                                        data[0].assigned_user_first_name +
                                        " " +
                                        data[0].assigned_user_last_name +
                                        " - " +
                                        data[0].assigned_user_email
                            };
                            self.contact_id = {
                                value: data[0].contact_id,
                                text: data[0].contact_first_name + " " + data[0].contact_last_name
                            };
                            self.customer_id = {
                                value: data[0].customer_id,
                                text: data[0].customer_firstname + " " + "(" + data[0].cusid + ")"
                            };
                            self.isDataEditable = true;
                        } else {
                            self.isDataEditable = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            getAccountId: function (id) {
                var self = this;

                //console.log("hello" + id);
            },
            formatString(data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            menuSmall: function () {
                $(".opensidebar").show();
                $(".closesidebar").hide();
                $(".menu").addClass("menusmall");
                $(".sidemenu li a span,.legal").addClass("displaynone");
                $(".sidemenu li a i").addClass("displayicons");
                $(".sidebar").css({width: "70px"});
                $(".content").css({marginLeft: "70px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            menuBig: function () {
                $(".opensidebar").hide();
                $(".closesidebar").show();
                $(".menu").removeClass("menusmall");
                $(".sidemenu li a span,.legal").removeClass("displaynone");
                $(".sidemenu li a i").removeClass("displayicons");
                $(".sidebar").css({width: "260px"});
                $(".content").css({marginLeft: "260px"});
                $("html, body").animate({scrollTop: 0}, 10);
            }
        }
    };
    EventBus.$on('logged-in', function (isLogin, fname, lname, email) {
        if (typeof (contex) != "undefined") {
            contex.isShowLoggedinfields = isLogin;
            contex.firstName = fname;
            contex.lastName = lname;
            contex.userName = email;
        }
    });
</script>




// WEBPACK FOOTER //
// src/components/cases/CaseCreate.vue